import {useAuthUserStore} from "@/stores/auth";

/*
 * Bloques de contenido de una lección (API V2, LMS-074 y LMS-218).
 * Cada bloque es { uuid, type, position, data } y `data` depende del tipo.
 * Las dos respuestas traen `meta.version`, la huella que se devuelve al guardar.
 */
const lessonBlocksUrl = (lessonUuid) => '/v2/lms/lessons/' + lessonUuid + '/blocks'

export default {
    index(lessonUuid) {
        return useAuthUserStore().getApiClient.get(lessonBlocksUrl(lessonUuid))
    },
    /*
     * Guarda la lista completa en una transacción: crea los bloques sin `uuid`,
     * actualiza los que lo traen, borra los que no llegan y deja el orden de la
     * lista. Con `version`, el backend responde 409 si otra persona ha guardado
     * entretanto.
     */
    sync(lessonUuid, blocks, version) {
        return useAuthUserStore().getApiClient.put(lessonBlocksUrl(lessonUuid), {
            blocks: blocks.map((block) => ({
                ...(block.uuid ? {uuid: block.uuid} : {}),
                type: block.type,
                data: block.data,
            })),
            version: version ?? null,
        })
    },
    /*
     * Sube la imagen de un bloque de imagen (LMS-071): multipart con el campo
     * `image`. Devuelve { data: { uuid, url } }; el bloque guarda el uuid.
     */
    uploadImage(lessonUuid, file, onProgress = null) {
        const form = new FormData()
        form.append('image', file)

        return useAuthUserStore().getApiClient.post('/v2/lms/lessons/' + lessonUuid + '/images', form, {
            headers: {'Content-Type': 'multipart/form-data'},
            onUploadProgress: (event) => {
                if (onProgress && event.total) onProgress(Math.round((event.loaded / event.total) * 100))
            },
        })
    },
    /*
     * Sube un fichero de un bloque de archivos (LMS-070): multipart con el campo
     * `file`. Devuelve { data: { uuid, name, size, url } }; el bloque guarda el uuid.
     */
    uploadFile(lessonUuid, file, onProgress = null) {
        const form = new FormData()
        form.append('file', file)

        return useAuthUserStore().getApiClient.post('/v2/lms/lessons/' + lessonUuid + '/files', form, {
            headers: {'Content-Type': 'multipart/form-data'},
            onUploadProgress: (event) => {
                if (onProgress && event.total) onProgress(Math.round((event.loaded / event.total) * 100))
            },
        })
    },
}
